module.exports = __webpack_public_path__ + "static/media/litres-ru-logo.b1b75d63.svg";